/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { GlobalAddressComponent } from './GlobalAddressComponent'
import type { GlobalContentComponent } from './GlobalContentComponent'
import type { GlobalMediaComponent } from './GlobalMediaComponent'
import type { ProfilingFilterTagComponent } from './ProfilingFilterTagComponent'
import type { ProfilingProfileComponent } from './ProfilingProfileComponent'
import type { UtilsMetaComponent } from './UtilsMetaComponent'
export type VacancyRequest = {
  data: {
    status?: VacancyRequest.status
    title: string
    slug?: string
    image?: number | string
    media?: GlobalMediaComponent
    content?: Array<GlobalContentComponent>
    address?: GlobalAddressComponent
    company?: number | string
    department?: number | string
    location?: number | string
    manager?: number | string
    tags?: Array<number | string>
    lastAddressStatus?: string
    interactions?: Array<number | string>
    profile?: ProfilingProfileComponent
    subtitle?: string
    appointments?: Array<number | string>
    BusinessIntelligence?: BusinessIntelligenceBiReportingComponent
    filterTags?: Array<ProfilingFilterTagComponent>
    referrals?: Array<number | string>
    disableGeoFilter?: boolean
    meta?: UtilsMetaComponent
  }
}
export namespace VacancyRequest {
  export enum status {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    CLOSED = 'closed',
    PAUSED = 'paused',
    NON_PUBLIC = 'non-public',
  }
}
